import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CitiesCreateRequestDTO, CitiesDeleteRequestDTO, CitiesDTO, CitiesList, CitiesReadAllPaginatedRequestDTO, CitiesReadByIdRequestDTO, CitiesReadByStateIdRequestDTO, CitiesUpdateRequestDTO } from './cities.interface';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { Cities_create, Cities_delete, Cities_update, Cities_readById, Cities_readAll, Cities_readAllPaginated, Cities_readByStateId } from 'src/app/GlobalVariables';
import { PaginatedDTO } from 'src/app/Common/common.interface';

@Injectable({
  providedIn: 'root'
})
export class CitiesService {


  constructor() { }
  cities$ = new BehaviorSubject<CitiesDTO[]>([])
  http = inject(HttpClient);

  Cities_create(data: CitiesCreateRequestDTO): Observable<CitiesDTO> {
    return this.http.post<CitiesDTO>(Cities_create, data)
  }

  Cities_update(data: CitiesUpdateRequestDTO): Observable<CitiesDTO> {
    return this.http.post<CitiesDTO>(Cities_update, data)
  }

  Cities_delete(data: CitiesDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(Cities_delete, data)
  }

  Cities_ReadById(data: CitiesReadByIdRequestDTO): Observable<CitiesDTO> {
    return this.http.post<CitiesDTO>(Cities_readById, data)
  }

  Cities_ReadAll(): Observable<CitiesList> {
    return this.http.get<CitiesList>(Cities_readAll).pipe(tap(res => {
      if (res?.items) {
        this.cities$.next(res.items.sort((a, b) => (a.cityName ?? '').localeCompare(b.cityName ?? '')));
      } else {
        this.cities$.next([]); // Ensure next() is always called
      }
    }));;
  }

  // Cities of one state only. Deliberately does NOT write into the shared cities$
  // subject (Cities_ReadAll owns that), so callers get just their state's list.
  Cities_ReadByStateId(data: CitiesReadByStateIdRequestDTO): Observable<CitiesList> {
    return this.http.post<CitiesList>(Cities_readByStateId, data)
  }

  Cities_ReadAllPaginated(data: PaginatedDTO): Observable<CitiesList>{
    return this.http.post<CitiesList>(Cities_readAllPaginated, data)
  }
  
}
